import React, { useEffect, useState } from "react";
import Header from "./Components/Header";
import Slider from "./Components/Slider";
import AboutCristo from "./Components/AboutCristo";
import WelcomeCristo from "./Components/WelcomeCristo";
import Footer from "./Components/Footer";
import { ThreeDots } from "react-loader-spinner";
import Faq from "./Components/Faq";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <ThreeDots
            visible={true}
            height="50"
            width="50"
            color="#ff8001"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <>
          <Header />
          <Slider />
          <AboutCristo />
          <WelcomeCristo />
          <br />
          <Faq />
          <Footer />
        </>
      )}
    </>
  );
};

export default Home;